import React, { FC } from 'react';
import styled from '@emotion/styled';
import { initialColors } from '@/theme/vivicaUiKitColors';
import { Theme } from '@mui/material';
import { inheritDataTestId } from '@/utils/testId.ts';
export const StyledDotsContainer = styled.div`
  display: flex;
  gap: 10px;
`;
export const StyledDot = styled.button<{
  selected?: boolean;
  size?: number;
  theme?: Theme;
}>`
  width: 18px;
  height: 18px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid
    ${({ selected }) => (selected ? 'transparent' : initialColors.grey7)};
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors.all.primaryLight : initialColors.white};
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: ${({ theme }) => theme.colors.all.primaryLight};
    border-color: ${({ theme }) => theme.colors.all.primaryLight};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.all.primaryDark};
    border-color: ${({ theme }) => theme.colors.all.primaryDark};
  }
`;
export const Dots: FC<{
  count: number;
  value: number;
  onChange: (n: number) => void;
}> = ({ count, value, onChange, ...props }) => {
  const dotsArray = [...Array(count)];
  return (
    <StyledDotsContainer>
      {dotsArray.map((_, i) => {
        return (
          <StyledDot
            data-test-id={inheritDataTestId(props, '_dot-button' + i)}
            key={i}
            selected={i === value}
            onClick={() => onChange(i)}
          />
        );
      })}
    </StyledDotsContainer>
  );
};
